import { FC } from 'react';
import { Select } from 'antd';
import { TransactionFormType } from 'typings/transactionForm';
import useTransactionFormStore from 'global/Securities/stores/useTransactionFormStore';
import useGlobalModalStore from 'global/GlobalModalManager/stores/useGlobalModalStore';
import useFastOrderForm from 'features/fast-order/stores/useFastOrderStore';
import tradingModalStore from 'global/TradingModal/store';
import { GlobalModalType } from 'global/GlobalModalManager/types';
import { SelectForm } from './styled';

interface FormTypeSelectProps {
  onChange?: (value: TransactionFormType) => void;
}

const FormTypeSelect: FC<FormTypeSelectProps> = ({ onChange }) => {
  const [classicSymbol, orderType, showTabs, showOrderbook] = tradingModalStore(
    (s) => [s.symbol, s.orderType, s.showTabs, s.showOrderbook],
  );
  const [formType, setFormType] = useTransactionFormStore((s) => [
    s.formType,
    s.setFormType,
  ]);
  const setSymbol = useFastOrderForm((s) => s.setSymbol);

  const [setActiveModal] = useGlobalModalStore((s) => [s.setActiveModal]);

  const handleSelectChange = (value: TransactionFormType) => {
    setSymbol(classicSymbol); // Update symbol used by classic form to fast order form
    setFormType(value);
    setActiveModal(GlobalModalType.FastOrder, {
      switchFormConfig: { orderType, showTabs, showOrderbook },
    });
    onChange(value);
  };

  return (
    <SelectForm value={formType} onChange={handleSelectChange}>
      {[
        { label: 'Classic', value: TransactionFormType.Classic },
        { label: 'Fast Order', value: TransactionFormType.FastOrder },
      ].map(({ label, value: selectValue }) => (
        <Select.Option key={selectValue} value={selectValue}>
          {label}
        </Select.Option>
      ))}
    </SelectForm>
  );
};

export default FormTypeSelect;
